import { ConfigPayment } from "../modules/paymethodConfig";

export const PaymenthPage = () => {
  return <ConfigPayment />;
};
